<template>
  <vx-card class="upgrade-list">
   <paging-list 
    class="vs-space-table"
    :data="list" 
    :total="total" 
    :limit="query.limit" 
    :page="query.page" 
    @pageChange="onPageChange"
  >
      <div slot="header" class="top w-full">
        <vx-form class="vx-row">
          <form-item label="搜索" class="vx-col sm:w-1/3 w-full mb-2">
            <vs-input class="w-full" placeholder="输入商品名称或ID" v-model="query.keyword" @keypress.enter="fetchList(1)" />
          </form-item>
          <form-item label="客户筛选" class="vx-col sm:w-1/3 w-full mb-2" v-if="$acl.check('customer_list')">
            <v-select placeholder="全部" :options="$s.user.customersAndMe()" label="userName" v-model="query.uid" :reduce="p => p.uid">
              <template v-slot:option="user">
                <span v-if="user.uid == $s.auth.user.uid">(我)</span>{{user.nickName}}[{{user.userName}}]【{{user.name}}】
              </template>
            </v-select>
          </form-item>
          <form-item class="vx-col sm:w-1/3 w-full mb-2">
            <vs-button class="mr-3 mb-2" @click="fetchList(1)">
              查询
            </vs-button>
            <vs-button v-if="$acl.check('product_edit')" to="/product/create" color="primary" type="border" class="mb-4 mr-4 cursor-pointer items-center justify-between font-medium text-base text-primary border border-solid border-primary">
              <icon icon="PlusIcon" svgClasses="h-4 w-4" style="top: 2px" />
              新建商品
            </vs-button>
          </form-item>
        </vx-form>
      </div>
      <template slot="thead">
      <vs-th>ID</vs-th>
        <vs-th>标题</vs-th>
        <vs-th v-if="$acl.check('product_admin')">用户ID</vs-th>
        <vs-th v-if="$acl.check('product_admin')">用户名</vs-th>
        <vs-th>简介</vs-th>
        <vs-th>规格/型号</vs-th>
        <vs-th>更新时间</vs-th>
        <vs-th>溯源资料</vs-th>
      <vs-th v-if="$acl.check('product_edit')">操作</vs-th>
    </template>
    <template slot-scope="{data}">
      <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
        <vs-td>{{tr.id}}</vs-td>
        <vs-td>{{tr.name}}</vs-td>
        <vs-td v-if="$acl.check('product_admin')">{{tr.uid}}</vs-td>
        <vs-td v-if="$acl.check('product_admin')">{{tr.nickName}} [{{tr.userName}}]</vs-td>
        <vs-td>{{tr.desc || '-'}}</vs-td>
        <vs-td>{{tr.spec || '-'}}</vs-td>
        <vs-td>{{tr.createdAt | datetime}}</vs-td>
        <vs-td>
          <div v-if="tr.enableBatch">
            <vs-button v-if="tr.batchNo.length" type="border" size="small" @click="$modal('batchList', {product: tr})">查看批号</vs-button>
            <vs-button v-else type="border" size="small" @click="addBatchNo(tr)">新建批号</vs-button>
          </div>
          <vs-button v-else type="border" size="small" @click="editDefaultBatch(tr)">编辑溯源</vs-button>
        </vs-td>
        <vs-td class="whitespace-no-wrap" v-if="$acl.check('product_edit')">
          <router-link :to="'/product/edit/' + tr.id" type="flat">编辑</router-link>
          <a @click.stop="willRemove(tr)" class="ml-5 text-danger">删除</a>
        </vs-td>
      </vs-tr>
    </template>
   </paging-list>
  </vx-card>
</template>
<script>
export default {
  data() {
    return {
      list: [],
      total: 0,
      query: {
        keyword: '',
        limit: 10,
        page: 1,
        uid: 0
      },
    }
  },
  mounted() {
    this.$s.user.getCompany()
    if (this.$acl.check('customer_list')) {
      this.$s.user.fetchCustomer()
    }
    this.query = {
      ...this.query,
      uid: Number(this.$route.query.customer || this.$route.query.uid || 0),
    }
  },
  methods: {
    onPageChange(p) {
      this.fetchList(p)
    },
    async fetchList(page) {
      if (page) {
        this.query.page = page
      }
      const q = {
        keyword: this.query.keyword,
        offset: (this.query.page - 1) * this.query.limit,
        limit: this.query.limit,
        status: this.query.status,
        uid: this.query.uid,
      }
      const {list, total} = await this.$s.product.fetchList(q)
      this.list = list
      this.total = total
    },
    willRemove(item) {
      this.$confirm({
        color: 'danger',
        title: '确定删除该商品？',
        text: '删除商品时会将关联的批号和溯源信息一并删除。 <br /><br />如果该商品未下单，您可以删除该商品，否则将删除失败。',
        accept: async () => {
          await this.$s.product.remove(item.id).then(() => {
            this.list = this.list.filter(x => x.id != item.id)
            this.$notify({
              color: 'success',
              title: '删除成功',
            })
          }).catch(err => {
            if (err.status == 100103) {
              setTimeout(() => {
                this.$notify({
                  color: 'danger',
                  title: '删除失败，请确认该商品是否可删除',
                })
              })
            }
            // throw err
          })

        }
      })
    },
    addBatchNo(item) {
      this.$modal('editBatchNo', {
        product: item,
        onOk(data) {
          item.batchNo.push(data)
        }
      })
    },


    editBatchNo(batch, product) {
      this.$modal('editBatchNo', {
        batch: batch,
        product: product,
        onOk(data) {
          batch.batchNo = data.batchNo
        }
      })
    },
    previewBatch(b) {
      this.$modal('previewTraceQr', {batchID: b.id})
    },
    async editDefaultBatch(product) {
      let defBatchNo = ''
      if (product.batchNo.length) {
        defBatchNo = product.batchNo[0].id
      } else {
        const batch = await this.$s.product.createBatchNo({
          productID: product.id,
          batchNo: '默认批号',
          isDefault: true,
        }).catch(err => {
          this.$notify({
            color: 'danger',
            title: '默认批号生成失败',
          })
          throw err
        })
        defBatchNo = batch.id
      }
      this.$router.push('/batchno/detail/' + defBatchNo)
    },
  },
}
</script>
